import { z } from 'zod';
import { parseStrictDate } from './strict-date.js';
/** Required date field where empty string and null both mean "not provided". */
export function requiredDateInput(label) {
    return z.union([z.string(), z.date(), z.null()]).transform((value, context) => {
        if (value === null || value === '') {
            context.addIssue({ code: 'custom', message: `${label} is required.` });
            return z.NEVER;
        }
        return parseStrictDate(value, context);
    });
}
//# sourceMappingURL=required-date-input.js.map